const TIME_FMT: Intl.DateTimeFormatOptions = {
  hour: '2-digit',
  minute: '2-digit',
  hour12: false,
};

function isSameLocalDay(a: Date, b: Date): boolean {
  return (
    a.getFullYear() === b.getFullYear() &&
    a.getMonth() === b.getMonth() &&
    a.getDate() === b.getDate()
  );
}

function isYesterdayLocal(target: Date, now: Date): boolean {
  const y = new Date(now);
  y.setDate(y.getDate() - 1);
  return isSameLocalDay(target, y);
}

function formatTime(d: Date): string {
  return d.toLocaleTimeString('es-ES', TIME_FMT);
}

function formatDayMonth(d: Date): string {
  const day = d.getDate();
  const month = d.toLocaleString('es-ES', { month: 'short' }).replace('.', '');
  return `${day} ${month}`;
}

export function formatRelativeDate(
  iso: string,
  now: Date = new Date()
): string {
  const target = new Date(iso);
  const diffMs = Math.max(0, now.getTime() - target.getTime());
  const diffSec = Math.floor(diffMs / 1000);
  const diffMin = Math.floor(diffMs / 60_000);

  if (diffSec < 60) return `hace ${diffSec}s`;
  if (diffMin < 60) return `hace ${diffMin}m`;
  const time = formatTime(target);
  if (isSameLocalDay(target, now)) return time;
  if (isYesterdayLocal(target, now)) return `ayer a las ${time}`;
  if (target.getFullYear() === now.getFullYear()) {
    return `${formatDayMonth(target)} ${time}`;
  }
  return `${formatDayMonth(target)} ${target.getFullYear()} ${time}`;
}

export function formatClosedAtRelative(
  iso: string,
  now: Date = new Date()
): string {
  const target = new Date(iso);
  const diffMs = Math.max(0, now.getTime() - target.getTime());
  const diffMin = Math.floor(diffMs / 60_000);

  if (diffMin < 1) return 'ahora mismo';
  if (diffMin < 60) return `hace ${diffMin}m`;
  const time = formatTime(target);
  if (isSameLocalDay(target, now)) return `a las ${time}`;
  if (isYesterdayLocal(target, now)) return `ayer a las ${time}`;
  return `el ${formatDayMonth(target)} ${time}`;
}
